const formatCases = (data: any) => {
  return {
    cases: Object.keys(data?.cases).map(caseRef => ({
      ...data?.cases[caseRef],
      tasks: data?.cases[caseRef]?.tasks
        ? Object.keys(data?.cases[caseRef]?.tasks).map(taskId => ({
            taskId,
            ...data?.cases[caseRef]?.tasks[taskId],
          }))
        : [],
      clientComments: data?.cases[caseRef]?.['client-comments']
        ? Object.keys(data?.cases[caseRef]?.['client-comments']).map(sectionType => ({
            sectionType,
            ...data?.cases[caseRef]?.['client-comments'][sectionType],
          }))
        : [],
    })),
  }
}

export default formatCases
